import _ from "underscore";

import { CanvasHandler } from "../../handlers";
import { FabricObject } from "../../types/FabricCustomType";
import { IObjectDetail } from "../../types/HandlerObjectType";
import { TooltipSeatDetail } from "../../components/tooltip/TooltipSeatDetail";
import store from "../../redux/store";
import { isTouchDevice, isTouchInteraction } from "../../utils/InteractionUtil";
import { getSvgObject, findObjectInCanvas } from "../../utils/ObjectUtil";
import { Icons } from "../../enums";
class Seat implements IObjectDetail {
    private canvasHandler: CanvasHandler;
    private targetSeat!: FabricObject<Object> | null;

    constructor(canvasHandler: CanvasHandler) {
        this.canvasHandler = canvasHandler;
    }

    public activateObjectHover(event: any, seat: FabricObject<Object>): any {
        if (this.targetSeat != seat) {
            this.deactivateObjectHover();//Elimina el hover del objeto anterior
            const seatCircle = seat.item(0);
            this.setTooltip(event, seat);

            if (seat.status == "Free" && seat.available) {
                seatCircle.set({
                    fill: `${seatCircle.stroke}90`,
                    radius: seatCircle.radius + 0.5,
                });
            }
            this.targetSeat = seat;
            this.canvasHandler.canvas.requestRenderAll();
        }

        if (this.targetSeat && this.targetSeat.available && this.targetSeat.status == "Free")
            this.canvasHandler.canvas.setCursor("pointer");
        else
            this.canvasHandler.canvas.setCursor("default");
    }

    public async handleObjectLockUpdate(valueHub: any): Promise<any> {
        const {
            properties: { channels },
        } = store.getState();
        valueHub.objects.forEach((item: any) => {
            const {object: seat} = findObjectInCanvas(this.canvasHandler, item.parentKey, item.objectKey);
            if (seat) {
                if (item.status == "Free" && ((item.channel?.key ?? null) == null || channels.includes(item.channel?.key ?? null))) {
                    this.releaseInCanvas(seat);
                } else {
                    this.holdInCanvas(seat, (item.channel?.key ?? null) == null ? item.status : "Reserved");
                }

                if (window.redseats.responseCallback && !isTouchDevice())
                    window.redseats.responseCallback();
                else
                    this.deactivateObjectHover();
            }
        });
    }

    public deactivateObjectHover = () => {
        if (this.targetSeat) {
            this.canvasHandler.tooltipHandler.hide();
            this.canvasHandler.canvas.setCursor("default");
            if (this.targetSeat.status == "Free" && this.targetSeat.available) {
                const seatCircle = this.targetSeat.item(0);
                seatCircle.set({
                    fill: `${seatCircle.stroke}40`,
                    radius: seatCircle.radius - 0.5,
                });
            }
            this.canvasHandler.canvas.requestRenderAll();
            this.targetSeat = null;
        }
        else {
            this.canvasHandler.tooltipHandler.hide();
            this.canvasHandler.canvas.setCursor("default");
        }
    };

    private async holdInCanvas(seat: any, status: string) {
        seat.set({
            status: status
        });
        const seatCircle = seat.item(0);
        const seatText = seat.item(1);
        const colorFill = seat.statusColor[status];
        seatCircle.set({
            fill: colorFill,
            stroke: "transparent",
        });
        seatText.set({
            visible: false,
        });

        const seatOldIcon = seat.item(2);
        if (seatOldIcon)
            seat.remove(seatOldIcon);

        this.canvasHandler.canvas.requestRenderAll();
    }

    private async releaseInCanvas(seat: any) {
        seat.set({
            status: "Free",
            available: true,
        });
        const seatCircle = seat.item(0);
        const seatText = seat.item(1);
        const hasSpecialIcon = (seat.accesible || seat.companion || seat.restrictedView);

        seatCircle.set({
            fill: `${seat.statusColor.Free}${this.canvasHandler.isInteractionEnabled ? "40" : "80"}`,
            stroke: this.canvasHandler.isInteractionEnabled ? seat.statusColor.Free : "transparent",
        });
        seatText.set({
            visible: !hasSpecialIcon && this.canvasHandler.isInteractionEnabled,
        });

        const seatCheckIcon = seat.item(2);
        if (seatCheckIcon) {
            seat.remove(seatCheckIcon);
        }

        if (hasSpecialIcon && this.canvasHandler.isInteractionEnabled) {
            if (seat.restrictedView)
                seat.insertAt(getSvgObject(Icons.restricted, (seatCircle.radius * 1.7), '#000000'), 2, true);
            else if (seat.accesible)
                seat.insertAt(getSvgObject(Icons.accesible, (seatCircle.radius * 1.7), '#000000'), 2, true);
            else if (seat.companion)
                seat.insertAt(getSvgObject(Icons.companion, (seatCircle.radius * 1.7), '#000000'), 2, true);
        }

        this.canvasHandler.canvas.requestRenderAll();
    }

    private setTooltip(event: any, seat: any) {
        const show = _.partial(this.canvasHandler.tooltipHandler.show, event.e);

        window.redseats.responseCallback = _.partial(
            this.showTooltip,
            show,
            seat,
            this,
            event
        );

        window.redseats.getTooltipInfo();
    }

    private showTooltip(
        show: any,
        seat: any,
        rowInstance: any,
        event: any,
        tooltipInfo: any
    ) {
        let handleSelectObject;
        if (isTouchInteraction(event))
            handleSelectObject = () => rowInstance.handleSelectObject(event.target.id, seat);

        const handleClose = () => {
            rowInstance.deactivateObjectHover();
        }

        window.redseats.responseCallback = _.partial(
            window.redseats.responseCallback,
            tooltipInfo
        );

        const htmlElement = TooltipSeatDetail(seat, tooltipInfo, handleSelectObject, handleClose);
        show(htmlElement);
    }
}
export default Seat;
